import { render, staticRenderFns } from "./PurchaseOrderList.vue?vue&type=template&id=a8fd0eca&scoped=true&"
import script from "./PurchaseOrderList.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderList.vue?vue&type=style&index=0&id=a8fd0eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fd0eca",
  null
  
)

export default component.exports